import React, { createRef } from 'react';

const withLazyLoadImages = (Component) => {
  class _Component extends React.Component {
    constructor(props) {
      super(props);
      this.ref = createRef();
    }

    static getInitialProps(context) {
      if (Component.getInitialProps) {
        return Component.getInitialProps(context);
      }
    }

    lazyLoad = (target) => {
      // IntersectionObserver supported by iOS since 12.2 version
      if (!window.IntersectionObserver && target) {
        target.src = target.getAttribute('data-src');
        return;
      }
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.target.getAttribute('data-src')) {
            entry.target.src = entry.target.getAttribute('data-src');
            entry.target.removeAttribute('data-src');
            observer.disconnect();
          }
        });
      });

      io.observe(target);
    };

    componentDidMount() {
      if (this.ref.current instanceof HTMLElement) {
        const targets = this.ref.current.querySelectorAll('[data-src]');
        targets.forEach(this.lazyLoad);
      }
    }

    render() {
      return <Component ref={this.ref} {...this.props} />;
    }
  }

  _Component.__docgenInfo = Component.__docgenInfo;

  return _Component;
};

export default withLazyLoadImages;
